import React from 'react';
import OpowiedzMiLanding from './components/landing/OpowiedzMiLanding';

function App() {
  return (
    <div className="App">
      <OpowiedzMiLanding />
    </div>
  );
}

export default App;